export default __webpack_public_path__ + "5a28224896de0d234de29e6d1e1bbacb.webp";